import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Box, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LazySection from "../../../components/LazySection";

export default function Common_html({ BlockData }) {
  const [isDesktop, setIsDesktop] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleOpen = (imageUrl) => {
    setPreviewImage(imageUrl);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setPreviewImage("");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(
        typeof window !== "undefined" ? window.innerWidth > 1199 : false
      );
    };

    handleResize();

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  return (
    <>
      <div
        className={`common_leftright_pattern_block_mainwrapper common_leftright_pattern_block_mainwrapper_layman ${BlockData.chapter_class}`}
      >
        {BlockData.blocks.map((block, index) => (
          <LazySection key={index} className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              {block.has_heading && (
                <div className="common_leftright_pattern_titleblock">
                  <div className="common_leftright_pattern_titleblock_commonwidth">
                    <span className="common_leftright_pattern_titleblock_inner">
                      <div className="common_leftright_pattern_titleblock_header_wrapper">
                        <h1
                          className="common_leftright_pattern_titleblock_header"
                          dangerouslySetInnerHTML={{
                            __html: block.heading_text,
                          }}
                        ></h1>
                      </div>
                    </span>
                  </div>
                </div>
              )}

              <div
                className={`common_leftright_pattern_block laymanexplanation_leftright_pattern_block${
                  index + 1
                }`}
              >
                <div className="common_leftright_pattern_content_commonwidth">
                  {(() => {
                    const renderContent = (contentItems) => {
                      let renderedElements = [];
                      let paragraphGroup = [];

                      contentItems.forEach((item, itemIndex) => {
                        if (item.type === "paragraph") {
                          paragraphGroup.push(
                            <p
                              className={`common_leftright_pattern_block_paragraph ${
                                item.greenline_beforepara
                                  ? "common_leftright_pattern_block_greenline_beforepara"
                                  : ""
                              }`}
                              dangerouslySetInnerHTML={{ __html: item.text }}
                              key={`paragraph-${itemIndex}`}
                            ></p>
                          );
                        } else {
                          if (paragraphGroup.length > 0) {
                            renderedElements.push(
                              <div
                                className="common_leftright_pattern_block_paragraph_wrapper_layman"
                                key={`paragraph-group-${renderedElements.length}`}
                              >
                                {paragraphGroup}
                              </div>
                            );
                            paragraphGroup = [];
                          }
                          switch (item.type) {
                            case "inside_heading":
                              renderedElements.push(
                                <h2
                                  className="common_leftright_pattern_block_heading_layman"
                                  key={`heading-${itemIndex}`}
                                  dangerouslySetInnerHTML={{
                                    __html: item.text,
                                  }}
                                ></h2>
                              );
                              break;
                            case "quote":
                              renderedElements.push(
                                <div
                                  className="common_leftright_pattern_block_quotation_wrapper"
                                  key={`quote-${itemIndex}`}
                                >
                                  <p
                                    className={`common_leftright_pattern_block_quotation ${
                                      item.greenline_beforepara
                                        ? "common_leftright_pattern_block_greenline_beforepara"
                                        : ""
                                    }`}
                                    dangerouslySetInnerHTML={{
                                      __html: item.text,
                                    }}
                                  ></p>
                                  <p
                                    className="common_leftright_pattern_block_quotation_owner"
                                    dangerouslySetInnerHTML={{
                                      __html: item.author,
                                    }}
                                  ></p>
                                </div>
                              );
                              break;
                            case "bulletpoint_list":
                              renderedElements.push(
                                <ul
                                  className={`common_leftright_pattern_block_bulletpoint_list common_leftright_pattern_block_bulletpoint_list${itemIndex}`}
                                  key={`ul-${itemIndex}`}
                                >
                                  {item.items.map((listItem, liIndex) => (
                                    <li
                                      className={`common_leftright_pattern_block_bulletpoint common_leftright_pattern_block_bulletpoint_ul-${itemIndex}li-${liIndex}`}
                                      key={`li-${itemIndex}-${liIndex}`}
                                      dangerouslySetInnerHTML={{
                                        __html: listItem,
                                      }}
                                    ></li>
                                  ))}
                                </ul>
                              );
                              break;
                            default:
                              break;
                          }
                        }
                      });

                      if (paragraphGroup.length > 0) {
                        renderedElements.push(
                          <div
                            className="common_leftright_pattern_block_paragraph_wrapper_layman"
                            key={`paragraph-group-final`}
                          >
                            {paragraphGroup}
                          </div>
                        );
                      }
                      return renderedElements;
                    };

                    let imageUrl = "";
                    if (
                      block.type == "position_bothsides" ||
                      block.type == "tableblock_position_bothsides" ||
                      block.type == "cardgrid_insideblock"
                    ) {
                      imageUrl = isDesktop
                        ? block.block_positioned_image_url_desktop
                        : block.block_positioned_image_url_mobile;
                    }

                    switch (block.type) {
                      case "position_bothsides":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}
                            <div
                              className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                                index % 2 === 0 ? "left" : "right"
                              }`}
                            >
                              {imageUrl &&
                                typeof imageUrl === "string" &&
                                imageUrl.length > 0 && (
                                  <div className="common_leftright_pattern_block_position_image_wrapper">
                                    <Image
                                      className="next_image"
                                      src={imageUrl}
                                      alt="Block Content"
                                      width={1200}
                                      height={800}
                                    />
                                  </div>
                                )}

                              {block.content && (
                                <div className="common_leftright_pattern_block_content_layman">
                                  {block.has_insideblock_heading && (
                                    <h2 className="common_leftright_pattern_block_heading_layman">
                                      {block.insideblock_heading_text}
                                    </h2>
                                  )}
                                  {renderContent(block.content)}
                                </div>
                              )}
                            </div>
                          </>
                        );

                      case "flex_bothsides":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}

                            <div
                              className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_flex_${
                                index % 2 === 0 ? "left" : "right"
                              }`}
                            >
                              {block.flex_image_url &&
                                typeof block.flex_image_url === "string" &&
                                block.flex_image_url.length > 0 && (
                                  <div className="common_leftright_pattern_block_flex_image_wrapper">
                                    <Image
                                      className="next_image"
                                      src={block.flex_image_url}
                                      alt="Flex Image"
                                      width={1200}
                                      height={800}
                                    />
                                  </div>
                                )}
                              {block.content && (
                                <div className="common_leftright_pattern_block_content_layman">
                                  {block.has_insideblock_heading && (
                                    <h2 className="common_leftright_pattern_block_heading_layman">
                                      {block.insideblock_heading_text}
                                    </h2>
                                  )}
                                  {renderContent(block.content)}
                                </div>
                              )}
                            </div>
                          </>
                        );

                      case "flex_bothsides_html_with_image":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}

                            <div
                              className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_flex_${
                                index % 2 === 0 ? "left" : "right"
                              }`}
                            >
                              <div className="common_leftright_pattern_block_flex_image_wrapper">
                                {block.flex_image_url &&
                                  typeof block.flex_image_url === "string" &&
                                  block.flex_image_url.length > 0 && (
                                    <Image
                                      className="next_image"
                                      src={block.flex_image_url}
                                      alt="Flex Image"
                                      width={1200}
                                      height={800}
                                    />
                                  )}
                                {block.flex_bothsides_html_with_image && (
                                  <div className="flex_bothsides_html_with_image_contentwrap">
                                    <h3 className="flex_bothsides_html_with_image_heading">
                                      {
                                        block.flex_bothsides_html_with_image_heading
                                      }
                                    </h3>
                                    <div className="flex_bothsides_html_with_image_content">
                                      {block.flex_bothsides_html_with_image_content &&
                                        block.flex_bothsides_html_with_image_content.map(
                                          (htmlString, index) => (
                                            <p
                                              key={index}
                                              dangerouslySetInnerHTML={{
                                                __html: htmlString,
                                              }}
                                            ></p>
                                          )
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              {block.content && (
                                <div className="common_leftright_pattern_block_content_layman">
                                  {block.has_insideblock_heading && (
                                    <h2 className="common_leftright_pattern_block_heading_layman">
                                      {block.insideblock_heading_text}
                                    </h2>
                                  )}
                                  {renderContent(block.content)}
                                </div>
                              )}
                            </div>
                          </>
                        );

                      case "flex_bothsides_with_imagepreview":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}
                            <div
                              className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_flex common_leftright_pattern_block_flex_${
                                index % 2 === 0 ? "left" : "right"
                              }`}
                            >
                              {block.flex_image_url &&
                                typeof block.flex_image_url === "string" &&
                                block.flex_image_url.length > 0 && (
                                  <div className="common_leftright_pattern_block_flex_image_wrapper">
                                    <div className="common_leftright_pattern_block_flex_image_imagepreview_logowrapper">
                                      <span
                                        className="common_leftright_pattern_block_flex_image_imagepreview_logoviewicon"
                                        onClick={() =>
                                          handleOpen(block.flex_image_url)
                                        }
                                      >
                                        <Image
                                          className="next_image"
                                          src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/viewicon.png"
                                          alt="View Icon"
                                          width={40}
                                          height={40}
                                        />
                                      </span>
                                      <Image
                                        className="next_image"
                                        src={block.flex_image_url}
                                        alt="Flex Image"
                                        width={1200}
                                        height={800}
                                      />
                                    </div>
                                  </div>
                                )}
                              {block.content && (
                                <div className="common_leftright_pattern_block_content_layman">
                                  {block.has_insideblock_heading && (
                                    <h2 className="common_leftright_pattern_block_heading_layman">
                                      {block.insideblock_heading_text}
                                    </h2>
                                  )}
                                  {renderContent(block.content)}
                                </div>
                              )}
                            </div>
                          </>
                        );

                      case "tableblock_position_bothsides":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            {block.tableblock_content && (
                              <div className="common_leftright_pattern_block_content_layman">
                                {block.has_insideblock_heading && (
                                  <h2 className="common_leftright_pattern_block_heading_layman">
                                    {block.insideblock_heading_text}
                                  </h2>
                                )}
                                <div className="common_leftright_pattern_block_tabletypeblock_contentwrapper">
                                  {block.tableblock_content &&
                                    block.tableblock_content
                                      .tableblock_content_left.length > 0 && (
                                      <div className="common_leftright_pattern_block_tabletypeblock_content common_leftright_pattern_block_tabletypeblock_contentleft">
                                        {block.tableblock_content.tableblock_content_left.map(
                                          (item, idx) => (
                                            <p
                                              className="common_leftright_pattern_block_tabletypeblock_paragraph"
                                              key={idx}
                                              dangerouslySetInnerHTML={{
                                                __html: item.text,
                                              }}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                  {block.tableblock_content
                                    .tableblock_content_right &&
                                    block.tableblock_content
                                      .tableblock_content_right.length > 0 && (
                                      <div className="common_leftright_pattern_block_tabletypeblock_content common_leftright_pattern_block_tabletypeblock_contentright">
                                        {block.tableblock_content.tableblock_content_right.map(
                                          (item, idx) => (
                                            <p
                                              className="common_leftright_pattern_block_tabletypeblock_paragraph"
                                              key={idx}
                                              dangerouslySetInnerHTML={{
                                                __html: item.text,
                                              }}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                          </div>
                        );

                      case "cardgrid_insideblock":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            <div className="common_leftright_pattern_block_content_layman">
                              {block.has_insideblock_heading && (
                                <h2 className="common_leftright_pattern_block_heading_layman">
                                  {block.insideblock_heading_text}
                                </h2>
                              )}
                              {block.content && renderContent(block.content)}

                              {block.cards && (
                                <div className="card_grid_wrapper">
                                  {block.cards.map((card, i) => (
                                    <div className="card_grid_item" key={i}>
                                      <div className="card_grid_title">
                                        {card.title}
                                      </div>
                                      <div className="card_grid_sect">
                                        <strong>Sect:</strong> {card.sect}
                                      </div>
                                      <div className="card_grid_date">
                                        <strong>Date:</strong> {card.date}
                                      </div>
                                      {card.description && (
                                        <div className="card_grid_description">
                                          {card.description}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        );

                      case "card_grid_display":
                        const cols = isDesktop ? block.columns_desktop || 2 : 1;
                        const themeMap = {
                          brown: {
                            background:
                              "linear-gradient(180deg,rgba(199, 62, 12, 1) 0%, rgba(110, 20, 6, 1) 100%)",
                            color: "#ffffff",
                          },
                          pink: {
                            background:
                              "linear-gradient(180deg,rgba(244, 101, 76, 1) 0%, rgba(203, 63, 42, 1) 100%)",
                            color: "#ffffff",
                          },
                          violet: {
                            background:
                              "linear-gradient(180deg,rgba(228, 78, 132, 1) 0%, rgba(203, 34, 95, 1) 100%)",
                            color: "#ffffff",
                          },
                          purple: {
                            background:
                              "linear-gradient(180deg,rgba(108, 80, 166, 1) 0%, rgba(83, 64, 152, 1) 100%)",
                            color: "#ffffff",
                          },
                          blue: {
                            background:
                              "linear-gradient(180deg,rgba(52, 168, 247, 1) 0%, rgba(21, 114, 226, 1) 100%)",
                            color: "#ffffff",
                          },
                          aquamarine: {
                            background:
                              "linear-gradient(180deg,rgba(17, 207, 235, 1) 0%, rgba(7, 136, 158, 1) 100%)",
                            color: "#ffffff",
                          },
                          turquoise: {
                            background:
                              "linear-gradient(180deg,rgba(22, 211, 199, 1) 0%, rgba(13, 133, 125, 1) 100%)",
                            color: "#fff",
                          },
                          green: {
                            background:
                              "linear-gradient(180deg,rgba(170, 223, 38, 1) 0%, rgba(144, 193, 21, 1) 100%)",
                            color: "#000000",
                          },
                        };

                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}
                            <div
                              className={`common_leftright_pattern_block_inner_wrapper `}
                            >
                              <div className="common_leftright_pattern_block_content_layman">
                                {block.has_insideblock_heading && (
                                  <h2 className="common_leftright_pattern_block_heading_layman">
                                    {block.insideblock_heading_text}
                                  </h2>
                                )}
                                {block.content && renderContent(block.content)}

                                <div
                                  className="card_grid_display_wrapper"
                                  style={{
                                    gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))`,
                                  }}
                                >
                                  {(block.cards || []).map(
                                    (card, cardIndex) => {
                                      const theme = themeMap[card.theme] || {};
                                      const style = {
                                        background:
                                          card.background ||
                                          theme.background ||
                                          "#111827",
                                        color:
                                          card.color ||
                                          theme.color ||
                                          "#ffffff",
                                      };

                                      return (
                                        <div
                                          className="card_grid_display_item"
                                          style={{ ...style }}
                                          key={cardIndex}
                                        >
                                          <div className="card_grid_display_title_group">
                                            {card.original_title && (
                                              <h3
                                                className="card_grid_display_original_title"
                                                dangerouslySetInnerHTML={{
                                                  __html: card.original_title,
                                                }}
                                              />
                                            )}
                                          </div>

                                          <div className="card_grid_display_content">
                                            {card.main_title && (
                                              <h2
                                                className="card_grid_display_main_title"
                                                dangerouslySetInnerHTML={{
                                                  __html: card.main_title,
                                                }}
                                              />
                                            )}

                                            {card.description && (
                                              <p
                                                className="card_grid_display_description"
                                                dangerouslySetInnerHTML={{
                                                  __html: card.description,
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );

                      case "titled_card_grid":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}
                            <div
                              className={`common_leftright_pattern_block_inner_wrapper `}
                            >
                              <div className="titled_card_grid_wrapper">
                                {block.grid_title && (
                                  <div className="titled_card_grid_title_bar">
                                    <h2>{block.grid_title}</h2>
                                  </div>
                                )}
                                <div className="titled_card_grid_container">
                                  {block.cards &&
                                    block.cards.map((card, cardIndex) => (
                                      <div
                                        className="titled_card_grid_item"
                                        key={cardIndex}
                                      >
                                        <div
                                          className={`titled_card_grid_content ${block.card_gradient_type}`}
                                        >
                                          <div className="titled_card_grid_text_wrapper">
                                            <h3 className="titled_card_grid_title">
                                              {card.title}
                                            </h3>
                                            <p className="titled_card_grid_description">
                                              {card.description}
                                            </p>
                                          </div>
                                          <div className="titled_card_grid_image_wrapper">
                                            <Image
                                              className="next_image"
                                              src={card.image_url}
                                              alt={card.title}
                                              width={150}
                                              height={220}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </>
                        );

                      case "zodiac_grid_with_description":
                        return (
                          <>
                            {block.has_blocktop_heading && (
                              <h1
                                className="layman_block_topheading"
                                dangerouslySetInnerHTML={{
                                  __html: block.blocktop_heading_text,
                                }}
                              />
                            )}
                            <div
                              className={`common_leftright_pattern_block_inner_wrapper `}
                            >
                              <div className="common_leftright_pattern_block_content_layman">
                              {block.zodiac_grid_with_description_heading && (
                                    <h2 className="zodiac_grid_heading">{block.zodiac_grid_with_description_heading}</h2>
                                )}
                              <div className="zodiac_grid_wrapper">
                                {block.cards &&
                                  block.cards.map((card, cardIndex) => (
                                    <div
                                      className="zodiac_card"
                                      key={cardIndex}
                                    >
                                      <div className="zodiac_card_header">
                                        <Image
                                          className="zodiac_card_glyph"
                                          src={card.sign_glyph_url}
                                          alt={`${card.title} Glyph`}
                                          width={48}
                                          height={48}
                                        />
                                        <div className="zodiac_card_titles">
                                          <h3 className="zodiac_card_sign_title">
                                            {card.title} 
                                          </h3>
                                          <p className="zodiac_card_tagline">
                                            {card.tagline}
                                          </p>
                                        </div>
                                        
                                      </div>
                                      
                                        <p className="zodiac_card_description_block">{card.description}</p>
                                    </div>
                                  ))}
                              </div>
                              </div>
                            </div>
                          </>
                        );

                      default:
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {block.content && (
                              <div className="common_leftright_pattern_block_content_layman">
                                {block.has_insideblock_heading && (
                                  <h2 className="common_leftright_pattern_block_heading_layman">
                                    {block.insideblock_heading_text}
                                  </h2>
                                )}
                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );
                    }
                  })()}
                </div>
              </div>
            </div>
          </LazySection>
        ))}
      </div>

      {showOtherBlocks && (
        <Modal
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className="modal_banner"
              component="div"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>

                <Image
                  src={previewImage}
                  alt="bannerLogo"
                  width={400}
                  height={100}
                  style={{ width: "100%", height: "100%" }}
                  priority={false}
                  placeholder="blur"
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                />
              </div>
            </Typography>
          </Box>
        </Modal>
      )}
    </>
  );
}
